<script setup lang="ts">
type Props = {
  item: Article
  event?: Article
}

const props = withDefaults(defineProps<Props>(), {})

const app = useNuxtApp()
const storeIndex = useStoreIndex()
const storeUser = useStoreUser()

const data = {
  tEyeCatch: null, // アイキャッチ情報
  sVenue: null, // 会場
  sVenueSP: null, // 会場(SP用)
  sMuseumArticleSlug: null, // ミュージアムスラッグ
  sPeriodLabel: null, // 会期
  sAddress: null, // 所在地
  sTell: null, // TEL
  sOfficialUrl: null, // 公式サイト
  sEventArticleSlug: null, // 展覧会スラッグ
}

const onClickDetail = () => {
  const to = `/present/${props.item.article_slug}`
  if (storeUser.state.isLogin) {
    navigateTo(to)
  } else {
    storeUser.setLoginRedirectPath(to)
    navigateTo(to)
  }
}

// プレゼントから表示カラム作成
if (!data.tEyeCatch) {
  data.tEyeCatch = app.$getEyeCatch(props.item)
} // アイキャッチ情報

// 親コンポーネントから設定が無ければ関連記事からイベント取得
let eventItem = props.event
if (!eventItem) {
  eventItem = app.$getArticleRelationsSingle(props.item, 'event', null)
}

if (eventItem) {
  // イベントから表示カラム作成
  if (!data.sVenue) {
    data.sVenue = app.$getEventVenue(eventItem, false)
  } // 会場
  if (!data.sVenueSP) {
    data.sVenueSP = app.$getEventPlace(eventItem)
  } // 会場(SP用)
  if (!data.sMuseumArticleSlug) {
    data.sMuseumArticleSlug = app.$getEventMuseumArticleSlug(eventItem)
  } // ミュージアムスラッグ
  if (!data.sAddress) {
    data.sAddress = app.$getEventAddress(eventItem, false)
  } // 住所
  if (!data.sPeriodLabel) {
    data.sPeriodLabel = app.$getEventPeriodLabel(eventItem)
  } // 開催中情報
  if (!data.sTell) {
    data.sTell = app.$getEventTell(eventItem)
  } // 電話番号
  if (!data.sOfficialUrl) {
    data.sOfficialUrl = app.$getPresentOfficialUrl(props.item, eventItem)
  } // 公式サイト
  if (!data.sEventArticleSlug) {
    data.sEventArticleSlug = eventItem.article_slug
  } // 展覧会スラッグ
}
</script>

<template>
  <div class="c-presentItem">
    <div class="c-presentItem_old">
      <div class="c-presentItem_old_card_content">
        <div
          v-if="data.tEyeCatch"
          class="c-presentItem_old_card_content_imageBox"
        >
          <div
            class="c-presentItem_ImageLink u-hoverZoom"
            v-on:click="onClickDetail()"
          >
            <CommonImage
              class="c-presentItem_old_card_content_imageBox_image"
              v-bind:src="data.tEyeCatch.oImg"
              v-bind:alt="item.title"
              error-src="/images/noimage.svg"
              object-fit="contain"
              object-position="top center"
            />
          </div>
          <div
            v-if="data.tEyeCatch.sCaption"
            class="c-presentItem_old_card_content_imageBox_caption"
          >
            {{ data.tEyeCatch.sCaption }}
          </div>
        </div>

        <div class="c-presentItem_old_card_content_detailBox">
          <div class="c-presentItem_old_card_content_detailBox_detail">
            <div class="c-presentItem_old_card_content_detailBox_detail_title">
              <nuxt-link
                class="c-clampLines is-clampline2"
                v-bind:to="`/present/${item.article_slug}`"
              >
                {{ item.title }}
              </nuxt-link>
            </div>

            <div
              v-if="data.sMuseumArticleSlug && data.sVenue"
              class="c-presentItem_old_card_content_detailBox_detail_info"
            >
              <div class="c-presentItem_old_card_content_detailBox_detail_label">
                会場
              </div>
              <div class="c-presentItem_old_card_content_detailBox_detail_venue">
                <nuxt-link
                  v-bind:to="`/museum/${data.sMuseumArticleSlug}`"
                >
                  <div v-html="app.$trimEnter(data.sVenue)" />
                </nuxt-link>
              </div>
            </div>
            <div
              v-if="data.sPeriodLabel"
              class="c-presentItem_old_card_content_detailBox_detail_info"
            >
              <div class="c-presentItem_old_card_content_detailBox_detail_label">
                会期
              </div>
              <div class="c-presentItem_old_card_content_detailBox_detail_time">
                {{ data.sPeriodLabel }}
              </div>
            </div>
            <div
              v-if="data.sAddress"
              class="c-presentItem_old_card_content_detailBox_detail_info"
            >
              <div class="c-presentItem_old_card_content_detailBox_detail_label">
                所在地
              </div>
              <div class="c-presentItem_old_card_content_detailBox_detail_location">
                {{ data.sAddress }}
              </div>
            </div>
            <div
              v-if="data.sTell"
              class="c-presentItem_old_card_content_detailBox_detail_info"
            >
              <div class="c-presentItem_old_card_content_detailBox_detail_label">
                TEL
              </div>
              <div class="c-presentItem_old_card_content_detailBox_detail_tell">
                {{ data.sTell }}
              </div>
            </div>
            <div
              v-if="data.sOfficialUrl"
              class="c-presentItem_old_card_content_detailBox_detail_info"
            >
              <div class="c-presentItem_old_card_content_detailBox_detail_label">
                公式サイト
              </div>
              <a
                v-bind:href="data.sOfficialUrl"
                class="c-presentItem_link"
                target="_blank"
              >
                {{ data.sOfficialUrl }}
              </a>
            </div>
            <div
              v-if="item.form_date_to"
              class="c-presentItem_old_card_content_detailBox_detail_info"
            >
              <div class="c-presentItem_old_card_content_detailBox_detail_label">
                締切
              </div>
              <div class="c-presentItem_old_card_content_detailBox_detail_deadline">
                {{ app.$getPeriodDayLabel(item.form_date_to) }}
              </div>
            </div>
          </div>
          <div
            class="c-presentItem_old_card_content_detailBox_link"
          >
            <nuxt-link
              v-if="data.sEventArticleSlug"
              class="c-presentItem_old_card_content_detailBox_link_button is-white"
              v-bind:to="`/event/${data.sEventArticleSlug}`"
            >
              <div class="c-presentItem_old_card_content_detailBox_link_button_text is-white">
                展覧会詳細をみる
              </div>
            </nuxt-link>
            <div
              class="c-presentItem_old_card_content_detailBox_link_button is-blue"
              v-on:click="onClickDetail()"
            >
              <div class="c-presentItem_old_card_content_detailBox_link_button_text is-blue">
                応募する
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="c-presentItem_new">
      <div class="c-presentItem_new_card">
        <div
          class="c-presentItem_ImageLink u-hoverZoom"
          v-on:click="onClickDetail()"
        >
          <div class="c-presentItem_new_card_image">
            <CommonImage
              v-bind:src="data.tEyeCatch.oImg"
              v-bind:alt="item.title"
              error-src="/images/noimage.svg"
              object-fit="cover"
              width="110"
            />
          </div>
        </div>

        <div class="c-presentItem_new_card_data">
          <div
            v-if="data.sVenueSP"
            class="c-presentItem_new_card_data_venue"
          >
            {{ data.sVenueSP }}
          </div>
          <div class="c-presentItem_new_card_data_title c-clampLines is-clampline2">
            {{ item.title }}
          </div>
          <div
            v-if="data.sPeriodLabel"
            class="c-presentItem_new_card_data_period"
          >
            {{ data.sPeriodLabel }}
          </div>
          <div
            v-if="item.form_date_to"
            class="c-presentItem_new_card_data_day"
          >
            締切：{{ app.$getPeriodDayLabel(item.form_date_to) }}
          </div>
        </div>
      </div>

      <div
        class="c-presentItem_new_link"
      >
        <nuxt-link
          v-if="data.sEventArticleSlug"
          class="c-presentItem_new_link_button is-white"
          v-bind:to="`/event/${data.sEventArticleSlug}`"
        >
          <div class="c-presentItem_new_link_button_text is-white">
            展覧会詳細をみる
          </div>
        </nuxt-link>
        <div
          class="c-presentItem_new_link_button is-blue"
          v-on:click="onClickDetail()"
        >
          <div class="c-presentItem_new_link_button_text is-blue">
            応募する
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-presentItem {
  width: 100%;

  &_old {
    @include responsive.mq_down(sp) {
      display: none;
    }

    &_card {
      display: flex;
      flex-direction: column;
      width: 100%;

      &_title {
        margin-bottom: 13px;
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 18px;
        font-weight: bold;
      }

      &_content {
        display: flex;
        font-family: var(--g_font_family_NotoSansCJKjp);

        @include responsive.mq_down(sp) {
          display: block;
        }

        &_imageBox {
          width: 150px;

          @include responsive.mq_down(sp) {
            width: 100%;
          }

          &_image {
            flex-shrink: 0;
            width: 150px;
            max-height: 212px;

            @include responsive.mq_down(sp) {
              width: 100%;
              max-height: none;
            }
          }

          &_caption {
            margin-top: 5px;
            color: var(--color_text_base);
            font-family: var(--g_font_family_NotoSansCJKjp);
            font-size: 12px;
            line-height: 2;
          }
        }

        &_detailBox {
          flex-grow: 1;
          margin-top: -3px;
          margin-left: 27px;
          font-family: var(--g_font_family_NotoSansCJKjp);

          @include responsive.mq_down(sp) {
            width: 100%;
            margin: 10px 0 0;
          }

          &_detail {
            color: var(--color_text_base);
            font-size: 14px;
            line-height: 1.8;

            &_title {
              margin-bottom: 12px;
              font-family: var(--g_font_family_NotoSansCJKjp);
              font-size: 18px;
              font-weight: bold;

              a {
                color: #252525;
                font-weight: bold;
              }
            }

            &_info {
              display: flex;
              margin-bottom: 1px;

              @include responsive.mq_down(sp) {
                display: flex;
              }
            }

            &_label {
              display: inline-block;
              min-width: 98px;
              color: var(--color_text_base);
              font-weight: bold;

              @include responsive.mq_down(sp) {
                flex-basis: 98px;
              }

              &::before {
                content: "";
                display: inline-block;
                position: relative;
                top: -2px;
                width: 8px;
                height: 8px;
                margin-right: 6px;
                background-color: var(--color_primary_link);
              }
            }

            &_venue {
              color: var(--color_primary_link);
            }

            &_deadline {
              color: var(--g_color_text_c20000);
              font-weight: bold;
            }
          }

          &_link {
            display: flex;
            margin-top: 10px;

            @include responsive.mq_down(sp) {
              flex-wrap: wrap;
              justify-content: center;
            }

            &_button {
              display: flex;
              flex: 0 0 auto;
              align-items: center;
              justify-content: center;
              width: 189px;
              height: 42px;
              margin: 0;
              transition: 300ms;
              border: 1px solid var(--g_color_table_border_gray);
              text-decoration: none;
              cursor: pointer;

              @include responsive.mq_down(sp) {
                width: 45%;
                min-width: 133px;
                max-width: 189px;
                margin: 0 6px 12px;
              }

              &:hover {
                opacity: 0.7;
              }

              &_icon {
                color: var(--color_primary_link);
                font-weight: bold;
              }

              &_text {
                color: var(--color_primary_link);
                font-size: 14px;
                font-weight: bold;
                line-height: 2.286;

                &.is-blue {
                  color: #fff;
                }
              }

              &.is-white {
                margin: 0 11px 0 0;

                @include responsive.mq_down(sp) {
                  margin: 0 6px 12px;
                }
              }

              &.is-blue {
                border-color: var(--color_primary);
                background-color: var(--color_primary);
                color: #fff;

                @include responsive.mq_down(sp) {
                  margin: 0 6px;
                }
              }
            }
          }
        }
      }
    }

    &_link {
      color: var(--color_primary_link);
    }
  }

  &_new {
    display: flex;
    flex-direction: column;

    @include responsive.mq_up(pc) {
      display: none;
    }

    &_card {
      display: flex;
      width: 100%;
      padding: 10px;
      border: 1px solid var(--g_color_border_gray);

      &_image {
        width: 110px;
      }

      &_data {
        margin-left: 10px;

        &_venue {
          margin-top: 1px;
          color: var(--color_text_lightgray);
          font-size: 12px;
        }

        &_title {
          margin-top: 5px;
          color: var(--color_text_base);
          font-size: 14px;
          font-weight: bold;
        }

        &_period {
          margin-top: 5px;
          font-size: 12px;
          line-height: 1.5;
        }

        &_day {
          margin-top: 5px;
          color: var(--g_color_text_c20000);
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    &_link {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      &_button {
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        justify-content: center;
        width: 189px;
        height: 42px;
        margin: 10px 5px 0;
        transition: 300ms;
        border: 1px solid var(--g_color_table_border_gray);
        text-decoration: none;
        cursor: pointer;

        @include responsive.mq_down(sp) {
          width: 45%;
          min-width: 133px;
          max-width: 189px;
        }

        @include responsive.mq_down(small) {
          width: 100%;
          max-width: 189px;
        }

        &:hover {
          opacity: 0.7;
        }

        &_icon {
          color: var(--color_primary_link);
          font-weight: bold;
        }

        &_text {
          color: var(--color_primary_link);
          font-size: 14px;
          font-weight: bold;
          line-height: 2.286;

          &.is-blue {
            color: #fff;
          }
        }

        &.is-blue {
          border-color: var(--color_primary);
          background-color: var(--color_primary);
          color: #fff;
        }
      }
    }
  }
}
</style>
